import { useQuery } from '@tanstack/react-query'
import { createContext, useContext, Dispatch, useState, useEffect } from 'react'
import { getUser } from '~/queries/getUser'

type UserInfo = {
  isLoading: boolean
  user: unknown
}

type AppContextProperties = {
  modalOpen: boolean
  user?: UserInfo
}

const defaultAppProperties: AppContextProperties = {
  modalOpen: false,
}

const MainAppContext = createContext<AppContextProperties>(defaultAppProperties)
const SetMainAppContext = createContext<Dispatch<AppContextProperties>>(() => {})

export const MainAppContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [appContext, setAppContext] = useState<AppContextProperties>(defaultAppProperties)
  const info = useQuery({ queryKey: ['user'], queryFn: getUser })
  const { data, isLoading } = info

  useEffect(() => {
    setAppContext({ ...appContext, user: { isLoading, user: data } })
  }, [data, isLoading])

  return (
    <MainAppContext.Provider value={appContext}>
      <SetMainAppContext.Provider value={setAppContext}>{children}</SetMainAppContext.Provider>
    </MainAppContext.Provider>
  )
}

export const useMainAppContext = () => {
  return useContext(MainAppContext)
}

export const useModalOpenAppContext = () => {
  const context = useContext(MainAppContext)
  return context.modalOpen
}

export const useSetModalStatusMainAppContext = () => {
  const currentMainAppData = useContext(MainAppContext)
  const setMainAppData = useContext(SetMainAppContext)
  return (value: boolean) => {
    setMainAppData({ ...currentMainAppData, modalOpen: value })
  }
}

export const useGetUserInfo = () => {
  const context = useContext(MainAppContext)
  return context.user
}
